import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { environment } from 'src/config/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { AuthService } from '../../services/auth.service'

@Component({ selector: 'app-auth-container', templateUrl: './auth-container.component.html', styleUrls: ['./auth-container.component.scss'], standalone: false })
export class AuthContainerComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  title: string
  subtitle: string
  valid = true
  dir: 'ltr' | 'rtl' = localStorage.getItem('selectedLanguage') === 'he' ? 'rtl' : 'ltr'

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.initSubscriptions()
  }

  get version() {
    return environment.version
  }

  private initSubscriptions() {
    this.authService.titleSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((title) => {
      this.title = title ?? ''
    })
    this.authService.subTitleSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((subtitle) => {
      this.subtitle = subtitle ?? ''
    })
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      this.dir = event.lang === 'he' ? 'rtl' : 'ltr'
    })
  }
}
